// extracted by mini-css-extract-plugin
export var indeterminate = "_40-5";
export var md = "_40-4";
export var semantic = "_40-6";
export var sm = "_40-3";
export var text = "_40-7";
export var toggleInput = "_40-0";
export var toggleSwitch = "_40-1";
export var xs = "_40-2";